import { useCart } from "../context/CartContext";
import { ShoppingBag } from "lucide-react";
import { motion } from "framer-motion";

export default function Header() {
  const { count, setOpen } = useCart();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-[150] backdrop-blur-xl bg-black/50 border-b border-white/5"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button onClick={() => scrollTo("top")} className="tatau-text font-display font-black text-3xl md:text-4xl tracking-tighter leading-none" data-testid="logo-btn">
          POLYON//PEPS
        </button>

        <nav className="hidden md:flex items-center gap-9 text-[11px] tracking-[0.25em] uppercase text-slate-400 font-mono2">
          <button onClick={() => scrollTo("compounds")} className="hover:text-[#00F0FF] transition-colors" data-testid="nav-compounds">Compounds</button>
          <button onClick={() => scrollTo("research")} className="hover:text-[#00F0FF] transition-colors" data-testid="nav-research">Research</button>
          <button onClick={() => scrollTo("calculator")} className="hover:text-[#00F0FF] transition-colors" data-testid="nav-calculator">Calculator</button>
          <button onClick={() => scrollTo("coa")} className="hover:text-[#00F0FF] transition-colors" data-testid="nav-coa">COAs</button>
          <button onClick={() => scrollTo("protocol")} className="hover:text-[#00F0FF] transition-colors" data-testid="nav-protocol">Protocol</button>
          <button onClick={() => scrollTo("more-info")} className="hover:text-[#00F0FF] transition-colors" data-testid="nav-moreinfo">More Info</button>
          <button onClick={() => scrollTo("lab")} className="hover:text-[#00F0FF] transition-colors" data-testid="nav-lab">The Lab</button>
        </nav>

        <button
          onClick={() => setOpen(true)}
          className="relative flex items-center gap-2 border border-[#00F0FF]/40 text-[#00F0FF] px-4 py-2 text-xs uppercase tracking-widest hover:bg-[#00F0FF] hover:text-black transition-colors font-mono2"
          data-testid="cart-open-btn"
        >
          <ShoppingBag size={15} strokeWidth={2} />
          <span className="hidden sm:inline">Cart</span>
          {count > 0 && (
            <span className="absolute -top-2 -right-2 bg-[#00F0FF] text-black text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full" data-testid="cart-count-badge">
              {count}
            </span>
          )}
        </button>
      </div>
    </motion.header>
  );
}
